import axios from 'axios'
import { clearToken, getRefreshToken, getToken, setRefreshToken, setToken } from '../utils/auth'
import { refreshApi } from './auth'

export const http = axios.create({
  baseURL: 'https://control-api.genrouter.com',
  timeout: 20000,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

http.interceptors.request.use((config) => {
  const token = getToken()
  if (token && !(config && config.headers && (config.headers.Authorization || config.headers.authorization))) {
    config.headers = config.headers || {}
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

let isRefreshing = false
let refreshQueue = []

function enqueueRefresh (cb) {
  refreshQueue.push(cb)
}

function flushRefreshQueue (token) {
  const q = refreshQueue
  refreshQueue = []
  q.forEach(fn => {
    try { fn(token) } catch (e) {}
  })
}

function redirectToLogin () {
  clearToken()
  if (typeof window !== 'undefined') {
    window.location.hash = '#/login'
  }
}

http.interceptors.response.use(
  (res) => res,
  async (error) => {
    const response = error && error.response
    const config = error && error.config

    if (!response || !config) throw error

    if (response.status !== 401 || config.__isRetryRequest) throw error

    if (config.url && (config.url.indexOf('/user/login') >= 0 || config.url.indexOf('/user/refresh') >= 0)) {
      redirectToLogin()
      throw error
    }

    const refreshToken = getRefreshToken()
    if (!refreshToken) {
      redirectToLogin()
      throw error
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        enqueueRefresh((newToken) => {
          if (!newToken) return reject(error)
          const nextConfig = { ...config, __isRetryRequest: true }
          nextConfig.headers = nextConfig.headers || {}
          nextConfig.headers.Authorization = 'Bearer ' + newToken
          resolve(http(nextConfig))
        })
      })
    }

    isRefreshing = true
    try {
      const data = await refreshApi(refreshToken)

      const newAccess = data && (data.access_token || data.accessToken || data.token)
      const newRefresh = data && (data.refresh_token || data.refreshToken)

      if (!newAccess) {
        flushRefreshQueue(null)
        redirectToLogin()
        throw error
      }

      setToken(newAccess)
      if (newRefresh) setRefreshToken(newRefresh)

      flushRefreshQueue(newAccess)

      const nextConfig = { ...config, __isRetryRequest: true }
      nextConfig.headers = nextConfig.headers || {}
      nextConfig.headers.Authorization = 'Bearer ' + newAccess
      return http(nextConfig)
    } catch (e) {
      flushRefreshQueue(null)
      redirectToLogin()
      throw e
    } finally {
      isRefreshing = false
    }
  }
)




// WEBPACK FOOTER //
// ./src/api/http.js